import { z } from 'zod';

/* ─────────── «Ждёт меня» и поручения (раздел 6.21: ЗД-01, ЗД-02) ─────────── */

const DateStr = z.iso.date();

export const INBOX_SOURCES = {
  procurement: 'Закупки',
  contracts: 'Договоры',
  finplan: 'Финансовый план',
  payments: 'Оплаты',
  card: 'Карточка проекта',
  suppliers: 'Контрагенты',
  tasks: 'Поручения',
  schedule: 'График',
  warehouse: 'Склад',
  norms: 'Нормативная база',
  support: 'Поддержка',
  video: 'Видеонаблюдение',
  changes: 'Изменения',
  site: 'Площадка',
  letters: 'Письма',
  fleet: 'Техника',
  integrations: 'Обмен с системами',
  license: 'Лицензия',
  platform: 'Владелец портала',
  supervision: 'Надзор',
} as const;
export type InboxSource = keyof typeof INBOX_SOURCES;

export const InboxItem = z.object({
  id: z.string(),
  source: z.enum(Object.keys(INBOX_SOURCES) as [InboxSource, ...InboxSource[]]),
  title: z.string(),
  details: z.string().nullable(),
  projectId: z.uuid().nullable(),
  projectCode: z.string().nullable(),
  due: DateStr.nullable(),
  overdue: z.boolean(),
  /** С какого момента дело ждёт: смена этапа, отправка на согласование */
  since: z.string().nullable(),
  actionLabel: z.string(),
  actionPath: z.string(),
});
export type InboxItem = z.infer<typeof InboxItem>;

export const TaskInput = z.object({
  title: z.string().trim().min(3).max(300),
  details: z.string().trim().max(4000).nullable().optional(),
  assigneeId: z.uuid(),
  projectId: z.uuid().nullable().optional(),
  dueDate: DateStr.nullable().optional(),
  linkPath: z
    .string()
    .trim()
    .max(300)
    .regex(/^\/[A-Za-z0-9/_-]*$/, 'Ссылка — путь внутри портала')
    .nullable()
    .optional(),
});
export type TaskInput = z.infer<typeof TaskInput>;

export const TaskView = z.object({
  id: z.uuid(),
  title: z.string(),
  details: z.string().nullable(),
  projectId: z.uuid().nullable(),
  projectCode: z.string().nullable(),
  assigneeId: z.uuid(),
  assigneeName: z.string(),
  createdById: z.uuid().nullable(),
  createdByName: z.string().nullable(),
  dueDate: DateStr.nullable(),
  status: z.enum(['open', 'done', 'cancelled']),
  overdue: z.boolean(),
  linkPath: z.string().nullable(),
  result: z.string().nullable(),
  doneAt: z.string().nullable(),
  createdAt: z.string(),
});
export type TaskView = z.infer<typeof TaskView>;

export const Person = z.object({ id: z.uuid(), fullName: z.string(), position: z.string().nullable() });
export type Person = z.infer<typeof Person>;
